import CreateVisualMatchingView from "@features/tools/view/visual-matching-view/create-visual-matching-view";

const CreateVisualMatching = () => {
  return <CreateVisualMatchingView />;
};

export default CreateVisualMatching;
